import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
var inputStyle = {
  display: 'none'
};

var FileInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FileInput, _PureComponent);

  var _super = _createSuper2(FileInput);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.input = void 0;
    _this.locked = false;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileInput, [{
    key: "bindElement",
    value: function bindElement(el) {
      this.input = el;
    }
  }, {
    key: "click",
    value: function click() {
      var _this2 = this;

      if (this.locked) return;
      this.locked = true;
      this.input.value = '';
      this.input.click();
      setTimeout(function () {
        _this2.locked = false;
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accept = _this$props.accept,
          onChange = _this$props.onChange,
          multiple = _this$props.multiple,
          webkitdirectory = _this$props.webkitdirectory;
      var OriginProps = {
        webkitdirectory: webkitdirectory
      };
      return (
        /*#__PURE__*/
        React.createElement("input", Object.assign({
          ref: this.bindElement,
          accept: accept,
          multiple: multiple,
          onChange: onChange,
          style: inputStyle,
          type: "file"
        }, OriginProps))
      );
    }
  }]);

  return FileInput;
}(PureComponent);

export default FileInput;